import React from 'react';
import { useMsal } from "@azure/msal-react";
import { LogOut } from 'lucide-react';
import { loginRequest } from "./authConfig";

interface ButtonProps {
  className?: string;
}

/**
 * SignInButton component renders a button that initiates the login process
 */
export const SignInButton: React.FC<ButtonProps> = ({ className = "btn btn-primary" }) => {
    const { instance } = useMsal();

    const handleLogin = (): void => {
        // Change from loginRedirect to loginPopup for better cross-origin token handling
        instance.loginPopup(loginRequest)
            .catch(error => {
                console.error("Login failed", error);
            });
    };

    return (
        <button onClick={handleLogin} className={className}>
            Sign In
        </button>
    );
};

/**
 * SignOutButton component renders a button that logs out the user
 */
export const SignOutButton: React.FC<ButtonProps> = ({ className = "btn btn-secondary" }) => {
    const { instance } = useMsal();

    const handleLogout = (): void => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    };

    return (
        <button onClick={handleLogout} className={className} title="Sign Out">
            <LogOut className="w-5 h-5" />
        </button>
    );
};

interface WelcomeUserProps {
    className?: string;
}

/**
 * WelcomeUser component displays a greeting with the user's name
 */
export const WelcomeUser: React.FC<WelcomeUserProps> = ({ className = "welcome-container" }) => {
    const { accounts } = useMsal();
    const username = accounts[0]?.name || accounts[0]?.username || "user";

    return (
        <div className={className}>
            <p>Welcome, {username}</p>
        </div>
    );
};
